export const message = {
    error: {
        barcode: {
            invalid_length: '読み取ったコードの桁数が不正です',
            invalid_check_digit: 'JANコードが正しくありません',
        },
        not_found: '該当するデータがありません',
        validation: {
            value: {
                required: '{name}が入力されていません'
            },
            string: {
                length: '{max}文字以内で入力してください'
            },
            date: {
                format: '日付を正しい形式で入力してください',
                validity: '正しい日付を入力してください',
                comparison: '{end}は{start}より未来の日付を指定してください'
            },
            integer: '{name}は整数値で入力してください',
            out_of_range: '{name}は{min}～{max}の範囲で入力してください',
            delivery_specified_date: {
                min: '納品指定日は翌日以降の日付を指定してください。',
                max: '納品指定日は一か月以内の日付を指定してください。',
                before_transitional_measures_date: '納品指定日は経過措置以前の日付を指定してください。'
            }
        }
    }
}